module.exports = __webpack_public_path__ + "img/Alexcoutcharmtable29.9905ffaa.jpg";